class BudgetLookup extends HTMLElement {
  constructor() {
    super();

    this.key = "AIzaSyC4r5CsrNZPBQ02NWNdOlYz0H8IPwL96Y4";
    this.sheetID = this.dataset.sheetId;
    this.data = null;
  }

  async connectedCallback() {
    this.form = this.querySelector("[data-form]");
    this.input = this.querySelector("[data-input]");
    this.content = this.querySelector("[data-content]");
    this.error = this.querySelector("[data-error]");

    if (!this.form || !this.input || !this.content || !this.error) {
      console.error("Budget Lookup: Required elements are missing.");
      return;
    }

    this.form.addEventListener("submit", this.handleSubmit.bind(this));

    try {
      this.data = await this.fetchData();

      if (!this.data || !Array.isArray(this.data)) {
        throw new Error("Spreadsheet returned no usable data.");
      }
    } catch (error) {
      console.error("Budget Lookup: Could not load spreadsheet.", error);
      this.data = [];
      this.error.classList.remove("hidden");
    }
  }

async fetchData() {
  const range = "Sheet1!A:F";

  const url = `https://sheets.googleapis.com/v4/spreadsheets/${this.sheetID}/values/${encodeURIComponent(range)}?key=${this.key}`;

  console.log("Budget Lookup sheet ID:", this.sheetID);
  console.log("Budget Lookup range:", range);

  const response = await fetch(url);
  const data = await response.json();

  if (!response.ok) {
    console.error("Google Sheets API error:", data);
    throw new Error(
      data?.error?.message ||
        `Google Sheets request failed: ${response.status}`
    );
  }

  console.log("Rows retrieved:", data.values?.length || 0);
  console.log(
    "First 10 IDs:",
    (data.values || []).slice(0, 10).map(row => row[0])
  );

  return data.values || [];
}

  handleSubmit(event) {
    event.preventDefault();

    const value = this.input.value.trim();

    if (!value) return;

    if (!this.data || !this.data.length) {
      this.content.innerHTML = "";
      this.error.classList.remove("hidden");
      return;
    }

    console.log("Search value:", value);
console.log("Spreadsheet data:", this.data);
console.log("First 10 column A values:", this.data.slice(0, 10).map(row => row[0]));

    const user = this.data.find((row) => row[0] === value);

    this.classList.toggle("is-empty", !user);

    if (user) {
      this.renderContent(user);
      this.error.classList.add("hidden");
    } else {
      this.content.innerHTML = "";
      this.error.classList.remove("hidden");
    }
  }

  renderContent(user) {
    const visibleColumns = [1, 2, 3, 4];

    const table = `
      <table style="width: 100%;">
        <thead>
          <tr>
            ${this.data[0]
              .map((col, index) =>
                visibleColumns.includes(index)
                  ? `<td><strong>${col}</strong></td>`
                  : ""
              )
              .join("")}
          </tr>
        </thead>

        <tbody>
          <tr>
            ${user
              .map((col, index) =>
                visibleColumns.includes(index)
                  ? `<td><strong>${col}</strong></td>`
                  : ""
              )
              .join("")}
          </tr>
        </tbody>
      </table>
    `;

    this.content.innerHTML = table;
  }
}

if (!customElements.get("service-awards-budget-lookup")) {
  customElements.define("service-awards-budget-lookup", BudgetLookup);
}